import type { FocusData } from '../../../../../api/initiative-client/initiative-client.type';
import type { Board, Team } from '../../../../../api/projects-client/projects-client.type';

/**
 * Generate a mapping of selection item IDs to their names
 *
 * @param selection Array of teams or boards to generate name mapping for
 * @returns Record mapping selection IDs to their display names
 */
const getSelectionNames = (selection: Team[] | Board[]): Record<string, string> => {
  const selectionNames: Record<string, string> = {};

  selection.forEach((item) => {
    selectionNames[item.id] = item.name;
  });

  return selectionNames;
};

/**
 * Check if focus data exists and contains any entries
 *
 * @param focusData Focus data object to check, or null if no data available
 * @returns True if focus data exists and has entries, false otherwise
 */
const hasFocusData = (focusData: FocusData | null): boolean => {
  if (!focusData) {
    return false;
  }

  return Object.keys(focusData).length > 0;
};

export { getSelectionNames, hasFocusData };
